import React, { useState } from 'react'
import Select from 'react-select'
import { Table, Modal } from 'rsuite';
import { deleteDomainUser } from '../../redux/actions/user';
import { useDispatch, useStore } from 'react-redux'
import { doGetDomainRequestorsByDomain } from '../../redux/actions/domain';
import { checkIsAdminOrModerator } from '../../services/helper';

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, users = [], ...props }) => {
  var statusBgClass = ''
  if (dataKey === 'fullName') {
    rowData[dataKey] = rowData?.user?.firstname + ' ' + rowData?.user?.lastname
  } else if (dataKey === 'email') {
    rowData[dataKey] = rowData?.user?.email
  } else if (dataKey === 'phone') {
    rowData[dataKey] = rowData?.user?.phone
  } else if (dataKey === 'status') {
    if (rowData?.role?.name && rowData?.role?.name === 'rejected') {
      rowData[dataKey] = 'Rejected'
      statusBgClass = 'bg-red'
    } else if (rowData?.role?.name && rowData?.role?.name === 'pending') {
      rowData[dataKey] = 'Pending'
      statusBgClass = 'bg-yellow'
    } else if (rowData?.role?.name && rowData?.role?.name !== 'pending' && rowData?.role?.name !== 'rejected') {
      rowData[dataKey] = 'Approved'
      statusBgClass = 'bg-green'
    }
  }
  return (
    <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
      {dataKey === 'serialNo' ?
        (props?.rowKey + 1)
        :
        dataKey === 'status' ?
          <h5 style={{ width: '60px' }} className={`btn text-white ${statusBgClass}`}>
            {rowData[dataKey]}
          </h5>
          :
          rowData[dataKey]
      }
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, onEdit, isAdminOrModerator, onDelete, roleId, ...props }) => {
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="d-flex gap-2">
        <button type="button" className="h4 pt-2 pb-2 rounded mb-0 bg-gray text-white children width-100" onClick={() => onEdit(rowData)}>Edit</button>
        { isAdminOrModerator && <button type="button" className="h4 pt-2 pb-2 rounded mb-0 bg-red text-white children width-100" onClick={() => onDelete(rowData)}>Delete</button>}
      </div>
    </Cell>
  )
}
const DomainRequestors = ({ domainRequestors, selectedDomain, onApproveDomainRequest, domainRoles, roleOptions, onChangeDomainRole, isEdit, onChangeIsEdit }) => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const { domain } = store
	const { currentDomain } = domain
	const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)

  const columns = [
    {
      label: 'No.',
      name: 'serialNo'
    },
    {
      label: 'Full Name',
      name: 'fullName'
    },
    {
      label: 'Email',
      name: 'email'
    },
    {
      label: 'Phone',
      name: 'phone'
    },
    {
      label: 'Status',
      name: 'status'
    }
  ]

  const [domainRequestor, setDomainRequestor] = useState({})
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [isDelete, setIsDelete] = useState(false)
  const [domainData, setDomainData] = useState({})

  const headerElement = columns.map((h, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          key={h.name}
          width={50}
        >
          <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
          <TableCell dataKey={h.name} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        key={h.name}
      >
        <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
        <TableCell dataKey={h.name} />
      </Column>
    )
  })

  const handleEditClick = (domainData) => {
    setDomainRequestor(domainData)
    onChangeIsEdit()
  }

  const onDeleteClick = (domainData) => {
    setDomainData(domainData)
    setIsDelete(true)
  }

  const onDeleteUser = () => {
    try {
			dispatch( deleteDomainUser({
				userId: domainData.userId,
        domainId: domainData.domainId
			})).then((res) => {
      setIsDelete(false)
      dispatch(
        doGetDomainRequestorsByDomain({
          domainId: selectedDomain.id
        })
      )
			})
		} catch (err) {
			console.log("err", err)
		}
  }

  const handleClose = () => {
    onChangeDomainRole(domainRequestor, domainRequestor?.role.id)
    setDomainRequestor({})
    onChangeIsEdit()
  }

  const handleCloseDeleteModal = () => {
    setIsDelete(false)
  }

  const paginatedData = domainRequestors?.sort((a, b) => {
  }).slice(limit * (page - 1), limit * page)

  return (
    <div className="domain-requestors">
      <div className="header pb-0">
        <div className="title">
          <h2 className='fw-bold mb-0 text-blue'>Users</h2>
        </div>
      </div>

      <div className='shadow mt-4 border border-2 rounded'>
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          data={paginatedData}
        >
          {headerElement}
          <Column
            width={200}
            fixed="right"
            key="action"
          >
            <HeaderCell className='text-black fw-bold'>Action</HeaderCell>
            <SelectorCell
              onEdit={handleEditClick}
              onDelete={onDeleteClick}
              isAdminOrModerator={isAdminOrModerator}
            />
          </Column>
        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={domainRequestors?.length || 0}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { setPage(event) }}
            onChangeLength={(limit) => { setLimit(limit) }}
          />
        </div>
      </div>
      {(isEdit || isDelete) &&
        <Modal
          backdrop={true}
          className="change-user-role-modal"
          show={isEdit || isDelete}
          size="xs"
          overflow={false}
          onClick={() => { isEdit ? handleClose() : handleCloseDeleteModal() }}
          onHide={() => { isEdit ? handleClose() : handleCloseDeleteModal() }}
        >
          <Modal.Header>
            <Modal.Title className='fw-bold text-black'>
              { isEdit ?  `Edit Status` : `Delete`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='mt-4 h-75'>
            <label className='h4 text-black'> { isEdit ?  `Status` : ``}</label>
            { isEdit ? <Select
              className="role-option h4 mb-0"
              options={roleOptions}
              value={roleOptions.find(roleOption => roleOption.value === domainRoles[domainRequestor?.id])}
              onChange={(role) => onChangeDomainRole(domainRequestor, role.value)}
            /> : <h4 className='text-black'>Are you sure you want to delete this user?</h4>}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className={`h4 mb-0 pt-2 pb-2 ${ isEdit ? 'btn-green' : 'bg-red text-white'} width-100 rounded`} onClick={() => isEdit ? onApproveDomainRequest(domainRequestor, 'approve') : onDeleteUser()}>
              { isEdit ? "Approve": "Delete"}
            </button>
            <button type="button" className="ms-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded" onClick={() => isEdit ? onApproveDomainRequest(domainRequestor, 'reject') : handleCloseDeleteModal()}>
            { isEdit ? "Decline": "Cancel"}
            </button>
          </Modal.Footer>
        </Modal>
      }
    </div>
  )
}

export default DomainRequestors